import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DocumentTypesComponent } from '../document-types/document-types.component';

import { User } from '../../../shared/models/user';
import { IBOMFileModel } from '../../../shared/models/document.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-bom-pdf-xlsx-icon',
    templateUrl: './bom-pdf-xlsx-icon.component.html',
    styleUrls: ['./bom-pdf-xlsx-icon.component.scss'],
    standalone: false
})
export class BomPdfXlsxIconComponent {

  @Input() user: User;
  @Input() displayPrice: boolean;
  @Input() isProjectBOM: boolean;

  @Output() downloadPDF = new EventEmitter<IBOMFileModel>();
  @Output() downloadExcel = new EventEmitter<IBOMFileModel>();

  @ViewChild('BOMDescription') bomDescription: DocumentTypesComponent;
  @ViewChild('BOMWithoutPriceDescription') bomWithoutPriceDescription: DocumentTypesComponent;

  onDownloadPDF() {
    this.downloadPDF.emit({
      user: this.user,
      fileName: this.displayPrice ? this.bomDescription.value : this.bomWithoutPriceDescription.value
    });
  }

  onDownloadExcel() {
    this.downloadExcel.emit({
      user: this.user,
      fileName: this.displayPrice ? this.bomDescription.value : this.bomWithoutPriceDescription.value
    });
  }
}
